import { ITabData } from '../types';

interface IPrepareTabs {
  tabs: ITabData[];
}

export function prepareTabs({ tabs }: IPrepareTabs) {
  return tabs.map((tab: ITabData) => ({
    value: tab.anchor,
    title: tab.title,
  }));
}
